
import { arrowLeft, arrowRight } from '@/static/arrows';

export default { 
  props: {
    carouselData: {
      type: Array,
      default: () => {
        return []
      },
    }
  },
  data() {
    return {
      imgLoaded: false,
      slickOptions: {
        lazyLoad: 'progressive',
        centerMode: true,
        centerPadding: '60px',
        variableWidth: true,
        slidesToShow: 1,
        dots: true,
        infinite: true,
        speed: 400,
        prevArrow: arrowLeft,
        nextArrow: arrowRight,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              variableWidth: false,
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              variableWidth: false,
              arrows: false,
              centerMode: true,
              centerPadding: '0px',
              slidesToShow: 1
            }
          }
        ]
      },
    };
  },
  mounted () {
    this.$emit('init')
  },
  computed: {
    isHaveCarouselData () {
      return this.carouselData.length > 0
    },
  },
  methods: {
    onImgLoad () {
      this.imgLoaded = true
    }
  }
}
